import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { NgxSmartModalService } from 'ngx-smart-modal';
import {Router} from "@angular/router";
import { InternationalPhoneNumberModule } from 'ngx-international-phone-number';
import { NgModule } from '@angular/core';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
  
})
export class RegisterComponent implements OnInit {
  constructor(public ngxSmartModalService: NgxSmartModalService, public http: HttpClient, private router: Router) {this.currency(), this.operator() } 
      currencyType: any[];
      operatorType: any[];
      loaded:boolean = false;
      name:string = '';
      mobNum:string = '';
      email:string = '';
      countrycode: any;
      password:string = '';
      currencyChoice:string = ''; //set for Nigerian Naira!
      mobOperatorChoice:string = ''; //set for MTN Nigeria
      preferredCountries = [
        {"country":"South Africa", "code":'za', "dialcode":"+27"},
        {"country":"Nigeria", "code":'ng', "dialcode":"+97"},
        {"country":"Tunisia", "code":'tu', "dialcode":"+22"},
        {"country":"Egypt", "code":'eg', "dialcode":"+20"}
      ];
     onMobNumKeyUp(event:any){
        this.mobNum = event.target.value;
      }
      onNameKeyUp(event:any){
        this.name = event.target.value;
     
      }
      onEmailKeyUp(event:any){
        this.email = event.target.value;
       
      }
      onPasswordKeyUp(event:any){
        this.password = event.target.value;
        
      }
      onCurrencyChoice(event:any){
        this.currencyChoice = event.target.value;
        
      }
      onMobOperatorChoice(event:any){
        this.mobOperatorChoice = event.target.value;
        
      }
      onCountryChoice(event:any) {
        this.countrycode = event.target.value;
        console.log('Country Info:')
        console.log(this.countrycode);
        
      }
      onCurrency(event:any) {
        this.currencyChoice = event.target.value;
        console.log('Currency Info:')
        console.log(this.currencyChoice);
        
      }
      public currency() {
        this.http.get('https://api-staging.videyo.tv/manage/listCurrencies',{
        })
        .subscribe(
          data => {
             this.currencyType = data['currency'];
             console.log('Currency');
             console.log(this.currencyType);
          },
          error => {
            if (error.status >= 400 && error.status < 500) { 
              this.ngxSmartModalService.create('myModal1', '').open();
            }
         else if (error.status >= 500) { 
location.reload();
        }
            console.log('ERROR:');
            console.log(error);
          }
      );
      }
      public operator() {
        this.http.get('https://api-staging.videyo.tv/manage/listMobileOperators',{
        })
        .subscribe(
          data => {
             this.operatorType = data['mobileOperator'];
          console.log(this.operator);
            },
            error => {
              if (error.status >= 400 && error.status < 500) { 
                this.ngxSmartModalService.create('myModal1', '').open();
              }
              else if (error.status >= 500) { 
                this.ngxSmartModalService.create('myModal2', '').open();
                
              }
              console.log('ERROR:');
              console.log(error);
            }
      );
      }
      public postProfile(){
        this.mobNum = this.mobNum.replace(' ', '').substring(1);
        var tempURL = 'https://api-staging.videyo.tv/manage/register?phoneNumber='+this.mobNum+'&password='+this.password+'&name='+this.name+'&email='+encodeURIComponent(this.email)+'&currencyId='+this.currencyChoice+'&mobileOperatorId='+this.mobOperatorChoice;
       
        this.http.post(tempURL, {}).subscribe(
          data => {
         
            this.router.navigate(['/login']);
          },
          error => {
           
            

          }
        )
   
      }
      


  ngOnInit() {
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.loaded = true;
    }, 1500);
  }

}
